import { render, staticRenderFns } from "./CreateManuiView.vue?vue&type=template&id=f52e57a0&"
import script from "./CreateManuiView.vue?vue&type=script&lang=js&"
export * from "./CreateManuiView.vue?vue&type=script&lang=js&"
import style0 from "./CreateManuiView.vue?vue&type=style&index=0&id=f52e57a0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports